// Recover from a stale lazy chunk after a hosting deploy.
//
// Every push to main redeploys Firebase Hosting with freshly hashed assets. A tab that
// loaded index.html before the deploy still points at the old chunk names, so its next
// route-level lazy import can fail ("Failed to fetch dynamically imported module:
// …/assets/course-detail-XXXX.js") and the router shows the error boundary. Vite fires
// `vite:preloadError` for exactly this case; reloading picks up the new index.html.
//
// Guarded by a per-URL sessionStorage flag so a genuinely broken build cannot loop:
// the second failure on the same URL falls through to the error boundary as before.

const KEY = 'ui.chunkReloadedFor';

export function installChunkReload(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('vite:preloadError', (event) => {
    const url = window.location.href;
    let already: string | null = null;
    try { already = sessionStorage.getItem(KEY); } catch { /* storage unavailable */ }
    if (already === url) return; // let the error boundary show it
    try { sessionStorage.setItem(KEY, url); } catch { /* storage unavailable */ }
    event.preventDefault();
    window.location.reload();
  });
  // A successful full load clears the guard for this URL so a later deploy can recover again.
  window.addEventListener('load', () => {
    try { if (sessionStorage.getItem(KEY) === window.location.href) sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  });
}
